import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import * as authStore from "../../store/auth.store";
import * as userStore from "../../../user/store/user.store";
import { Layout } from "../../../layout/components/layout.component";
import IdleTimer from "react-idle-timer";
import { IDLE_TIMEOUT_MS } from "../../../../constants/config";
import { CustomRouteProps } from "../../../../types/routing/custom-route.props";

export const ProtectedRoute = (props: CustomRouteProps) => {
  const Component = props.route.component;
  const header = props.route.header;
  const isAuthenticated = useSelector(authStore.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      authStore.authenticate();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Route
      exact={props.exact}
      path={props.path}
      render={(props) => (
        <IdleTimer onIdle={userStore.logout} timeout={IDLE_TIMEOUT_MS}>
          <Layout header={header}>
            <Component {...props} />
          </Layout>
        </IdleTimer>
      )}
    />
  );
};
